import { render, staticRenderFns } from "./ListPageProfilesPage.vue?vue&type=template&id=26671808&scoped=true&"
import script from "./ListPageProfilesPage.vue?vue&type=script&lang=ts&"
export * from "./ListPageProfilesPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26671808",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
